import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

const ProtectedRouteSuperAdmin = ({ children }) => {
  const token = sessionStorage.getItem("token");
  const role = sessionStorage.getItem("role");

  if (!token || role !== "SUPERADMIN") {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  return children;
};

ProtectedRouteSuperAdmin.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRouteSuperAdmin;
